import React, { useState } from "react";
import ManageHotels from "./ManageHotels";
import { classNames } from "../../../utils/classNames";
import AddHotel from "./AddHotel";

// const RenderDetails = ({ label, value }: { label: string; value: string }) => {
//   return (
//     <div className="flex flex-row justify-between items-center mb-3 text-sm">
//       <span className="text-[#5D6679]">{label} </span>
//       <p className="font-bold pl-5 text-right break-words">{value}</p>
//     </div>
//   );
// };

const Profile = () => {
  const [activeTab, setActiveTab] = useState<
    "profile" | "hotels" | "add-hotel"
  >("profile");
  const handleSetActive = (active: "profile" | "hotels" | "add-hotel") =>
    setActiveTab(active);
  return (
    <div>
      <div className="mb-5">
        <h1 className="page-title mb-0">Profile</h1>
        <button
          className={classNames(
            "font-medium text-[#5D6679] text-sm md:text-lg mr-4",
            activeTab === "profile" ? "underline" : ""
          )}
          onClick={() => handleSetActive("profile")}
          type="button"
        >
          Manage your profile
        </button>
        <button
          className={classNames(
            "font-medium text-[#5D6679] text-sm md:text-lg",
            ["add-hotel", "hotels"].includes(activeTab) ? "underline" : ""
          )}
          onClick={() => handleSetActive("hotels")}
          type="button"
        >
          Manage your hotels
        </button>
        {activeTab === "profile" && (
          <div className="flex flex-wrap my-5 -mx-2">
            <div className="w-full md:w-6/12 px-2">
              {/* <Box title="">
              <>
                <h4 className="text-base md:text-xl mb-3">User Details</h4>
                <RenderDetails label="Full name" value="John" />
                <RenderDetails
                  label="Work email"
                  value="john-s@westworld.com"
                />
                <RenderDetails label="Role" value="CFO" />
                <RenderDetails label="DOB" value="--" />
                <RenderDetails label="Nationality" value="UK" />
                <RenderDetails
                  label="Residency Address"
                  value="49 Featherstone Street, London, UK, EC1Y 8SY"
                />
                <RenderDetails
                  label="Personal Email"
                  value="johnsmith@gmail.com"
                />
                <RenderDetails label="Card ID" value="G909066U" />
                <RenderDetails label="Phone Nr." value="+441234567890" />
              </>
            </Box> */}
            </div>
          </div>
        )}
        {activeTab === "hotels" && <ManageHotels setActive={handleSetActive} />}
        {activeTab === "add-hotel" && <AddHotel setActive={handleSetActive} />}
      </div>
    </div>
  );
};

export default Profile;
